var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "upload" },
    [
      _vm.sortable
        ? _c(
            "draggable",
            _vm._b(
              {
                staticClass: "upload-sort-root",
                attrs: {
                  list: _vm.fileList,
                  tag: "div",
                  draggable: ".upload-sort-item",
                  disabled: _vm.disabled || _vm.sortDisabled,
                },
                on: { end: _vm.handleSortEnd },
              },
              "draggable",
              {
                animation: 200,
              },
              false
            ),
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _vm.fileList.length < _vm.maxLength
                    ? [
                        _vm.type === "card"
                          ? [
                              _c(
                                "el-upload",
                                {
                                  ref: "upload",
                                  staticClass: "uploadView m-r-16",
                                  class: { disabledUpload: _vm.disabled },
                                  style: {
                                    width: _vm.width + "px",
                                    height: _vm.height + "px",
                                    ..._vm.customStyle,
                                  },
                                  attrs: {
                                    drag: _vm.drag,
                                    disabled: _vm.disabled,
                                    action: "#",
                                    limit: _vm.maxLength,
                                    multiple: _vm.maxLength > 1,
                                    accept: _vm.accept,
                                    "before-upload": _vm.beforeUpload,
                                    "http-request": _vm.upload,
                                    "show-file-list": false,
                                  },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-plus" }),
                                  _c("div", { staticClass: "uploadViewText" }, [
                                    _vm._v(_vm._s(_vm.uploadText)),
                                  ]),
                                ]
                              ),
                            ]
                          : _vm.type === "btn"
                          ? [
                              _c(
                                "el-upload",
                                {
                                  ref: "upload",
                                  class: { disabledUpload: _vm.disabled },
                                  style: {
                                    width: _vm.width + "px",
                                    height: _vm.height + "px",
                                    ..._vm.customStyle,
                                  },
                                  attrs: {
                                    disabled: _vm.disabled,
                                    action: "#",
                                    drag: _vm.drag,
                                    limit: _vm.maxLength,
                                    multiple: _vm.maxLength > 1,
                                    accept: _vm.accept,
                                    "before-upload": _vm.beforeUpload,
                                    "http-request": _vm.upload,
                                    "show-file-list": false,
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        slot: "trigger",
                                        disabled: _vm.disabled,
                                        icon: "el-icon-plus",
                                        size: "small",
                                        type: "primary",
                                      },
                                      slot: "trigger",
                                    },
                                    [_vm._v(_vm._s(_vm.uploadText))]
                                  ),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                        _vm.type === "digitalPerson"
                          ? [
                              _c(
                                "el-upload",
                                {
                                  ref: "upload",
                                  staticClass: "uploadVideo-box-wrapper",
                                  class: { disabledUpload: _vm.disabled },
                                  style: {
                                    width: _vm.width + "px",
                                    height: _vm.height + "px",
                                    ..._vm.customStyle,
                                  },
                                  attrs: {
                                    drag: _vm.drag,
                                    disabled: _vm.disabled,
                                    action: "#",
                                    limit: _vm.maxLength,
                                    multiple: _vm.maxLength > 1,
                                    accept: _vm.accept,
                                    "before-upload": _vm.beforeUpload,
                                    "http-request": _vm.upload,
                                    "show-file-list": false,
                                  },
                                },
                                [
                                  _c("div", { staticClass: "video-box" }, [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/image/plus-blue.png"),
                                      },
                                    }),
                                  ]),
                                  _c("div", { staticClass: "text" }, [
                                    _vm._v(_vm._s(_vm.uploadText)),
                                  ]),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._l(_vm.fileList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: item.url || item.name || index,
                    staticClass: "upload-sort-item m-r-16",
                  },
                  [
                    _c("uploadItem", {
                      attrs: {
                        index: index,
                        status: item.status,
                        "err-tips": item.errTips,
                        url: item.url,
                        accept: _vm.accept,
                        width: _vm.width,
                        disabled: _vm.disabled,
                        height: _vm.height,
                        "auth-progress": item.authProgress,
                        "before-upload": _vm.beforeUpload,
                        "upload-show-arr": _vm.uploadShowArr,
                      },
                      on: {
                        del: function ($event) {
                          return _vm.delFile(item, index)
                        },
                        again: function ($event) {
                          return _vm.alignUpload(item, index)
                        },
                        upload: _vm.uploadChange,
                        onClick: (res) => _vm.$emit("onClick", res),
                      },
                    }),
                  ],
                  1
                )
              }),
            ],
            2
          )
        : [
            _vm.fileList.length < _vm.maxLength
              ? [
                  _vm.type === "card"
                    ? [
                        _c(
                          "el-upload",
                          {
                            ref: "upload",
                            staticClass: "uploadView m-r-16",
                            class: { disabledUpload: _vm.disabled },
                            style: {
                              width: _vm.width + "px",
                              height: _vm.height + "px",
                              ..._vm.customStyle,
                            },
                            attrs: {
                              drag: _vm.drag,
                              disabled: _vm.disabled,
                              action: "#",
                              limit: _vm.maxLength,
                              multiple: _vm.maxLength > 1,
                              accept: _vm.accept,
                              "before-upload": _vm.beforeUpload,
                              "http-request": _vm.upload,
                              "show-file-list": false,
                            },
                          },
                          [
                            _c("i", { staticClass: "el-icon-plus" }),
                            _c("div", { staticClass: "uploadViewText" }, [
                              _vm._v(_vm._s(_vm.uploadText)),
                            ]),
                          ]
                        ),
                      ]
                    : _vm.type === "btn"
                    ? [
                        _c(
                          "el-upload",
                          {
                            ref: "upload",
                            class: { disabledUpload: _vm.disabled },
                            style: {
                              width: _vm.width + "px",
                              height: _vm.height + "px",
                              ..._vm.customStyle,
                            },
                            attrs: {
                              disabled: _vm.disabled,
                              action: "#",
                              drag: _vm.drag,
                              limit: _vm.maxLength,
                              multiple: _vm.maxLength > 1,
                              accept: _vm.accept,
                              "before-upload": _vm.beforeUpload,
                              "http-request": _vm.upload,
                              "show-file-list": false,
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  slot: "trigger",
                                  disabled: _vm.disabled,
                                  icon: "el-icon-plus",
                                  size: "small",
                                  type: "primary",
                                },
                                slot: "trigger",
                              },
                              [_vm._v(_vm._s(_vm.uploadText))]
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _vm.type === "digitalPerson"
                    ? [
                        _c(
                          "el-upload",
                          {
                            ref: "upload",
                            staticClass: "uploadVideo-box-wrapper",
                            class: { disabledUpload: _vm.disabled },
                            style: {
                              width: _vm.width + "px",
                              height: _vm.height + "px",
                              ..._vm.customStyle,
                            },
                            attrs: {
                              drag: _vm.drag,
                              disabled: _vm.disabled,
                              action: "#",
                              limit: _vm.maxLength,
                              multiple: _vm.maxLength > 1,
                              accept: _vm.accept,
                              "before-upload": _vm.beforeUpload,
                              "http-request": _vm.upload,
                              "show-file-list": false,
                            },
                          },
                          [
                            _c("div", { staticClass: "video-box" }, [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/image/plus-blue.png"),
                                },
                              }),
                            ]),
                            _c("div", { staticClass: "text" }, [
                              _vm._v(_vm._s(_vm.uploadText)),
                            ]),
                          ]
                        ),
                      ]
                    : _vm._e(),
                ]
              : _vm._e(),
            _vm._l(_vm.fileList, function (item, index) {
              return [
                _c("uploadItem", {
                  key: index,
                  staticClass: "m-r-16",
                  attrs: {
                    index: index,
                    status: item.status,
                    "err-tips": item.errTips,
                    url: item.url,
                    accept: _vm.accept,
                    width: _vm.width,
                    disabled: _vm.disabled,
                    height: _vm.height,
                    "auth-progress": item.authProgress,
                    "before-upload": _vm.beforeUpload,
                    "upload-show-arr": _vm.uploadShowArr,
                  },
                  on: {
                    del: function ($event) {
                      return _vm.delFile(item, index)
                    },
                    again: function ($event) {
                      return _vm.alignUpload(item, index)
                    },
                    upload: _vm.uploadChange,
                    onClick: (res) => _vm.$emit("onClick", res),
                  },
                }),
              ]
            }),
          ],
      _vm._t("tips"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }